import { traverseContentField } from '@dossierhq/core';
export function* traverseEntityEditorDraft(schema, draftState) {
    if (!draftState.draft) {
        return;
    }
    const path = [`draft(${draftState.id})`, 'fields'];
    for (const field of draftState.draft.fields) {
        const { fieldSpec, value } = field;
        const fieldPath = [...path, fieldSpec.name];
        yield* traverseContentField(schema, fieldPath, fieldSpec, value);
    }
}
//# sourceMappingURL=EntityDraftTraverser.js.map